import { PricingRules } from './pricing-rules';
import { ProductSelector } from './product-selector';
import { ImportPricingLevelsButton } from './import-pricing-levels-button';
import { SaveConditionalPricingButton } from './save-conditional-pricing-button';
import { ExportPricingLevelsButton } from './export-pricing-levels-button';

export function PricingRulesEditor() {
	return (
		<div>
			<div className="gw-conditional-pricing-buttons gform-settings-panel__content gw-flex gw-flex-row gwcp-flex-space-between">
				<ProductSelector />
				<div className="gw-flex gw-flex-row">
					<ExportPricingLevelsButton />
					<ImportPricingLevelsButton />
					<SaveConditionalPricingButton />
				</div>
			</div>
			<PricingRules />
		</div>
	);
}
